import { render, staticRenderFns } from "./QuickSelectTab.vue?vue&type=template&id=00bc01d6&scoped=true&"
import script from "./QuickSelectTab.vue?vue&type=script&lang=js&"
export * from "./QuickSelectTab.vue?vue&type=script&lang=js&"
import style0 from "./QuickSelectTab.vue?vue&type=style&index=0&id=00bc01d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bc01d6",
  null
  
)

export default component.exports